import styled from 'styled-components';

import { theme } from '../layout/theme';
import { size } from '../layout/helpers';

interface ITableRow {
  background?: boolean;
}

export const TableRow = styled.tr<ITableRow>`
  display: table-row;
  background: ${({ background }) => (background ? theme.colors.bg.accent : 'none')};
`;

export const TableCell = styled.td`
  display: table-cell;
  padding: ${size(2)} ${size(0.5)};

  &.align-right {
    text-align: right;
  }

  &.grow {
    width: 100%;
  }

  &:first-child {
    padding-left: ${size(2)};
  }

  &:last-child {
    padding-right: ${size(2)};
  }
`;

export const Table = styled.table`
  display: table;
  width: 100%;

  &.rounded {
    border-spacing: 0;

    ${TableCell}:first-child {
      border-bottom-left-radius: 4px;
      border-top-left-radius: 4px;
    }

    ${TableCell}:last-child {
      border-bottom-right-radius: 4px;
      border-top-right-radius: 4px;
    }
  }
`;
